// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Textarea_textarea__Ex3Ek","textareaElement":"Textarea_textareaElement__NBuJJ"};